import React, { Component } from 'react';
import moment from 'moment';

import Icon from '../../../../../../../components/Icon';

// css
import './styles.css';

export default class NfTableBody extends Component {
  _renderIconForNfSelected = nf => (this.props.nfSelecteds.filter(nfSelected => { return JSON.stringify(nfSelected) === JSON.stringify(nf) }).length === 1 ? 'minus' : 'plus');

  _renderClassForNfSelected = nf => (this.props.nfSelecteds.filter(nfSelected => { return JSON.stringify(nfSelected) === JSON.stringify(nf) }).length === 1 ? 'NfTableBody__row--selected' : '');

  render() {
    const { data, selectNf } = this.props;

    return (
      <tbody className="NfTableBody">
        {
          data.map(nf => (
            <tr key={nf.nf} className={`NfTableBody__row ${this._renderClassForNfSelected(nf)}`} >
              <td className={`NfTableBody__cell NfTableBody__cell--center NfTableBody__cell--icon-${this._renderIconForNfSelected(nf)}`}><Icon name={this._renderIconForNfSelected(nf)} onClick={() => (selectNf(nf))} /></td>
              <td className="NfTableBody__cell NfTableBody__cell--left" >{`${nf.nf}-${nf.nfGroup}`}</td>
              <td className="NfTableBody__cell NfTableBody__cell--left" >{nf.receiver}</td>
              <td className="NfTableBody__cell NfTableBody__cell--center" >{`${nf.cidade}/${nf.uf}`}</td>
              <td className="NfTableBody__cell NfTableBody__cell--center" >{this.props.getLabelById(nf.type)}</td>
              <td className="NfTableBody__cell NfTableBody__cell--right" >{nf.volume}</td>
              <td className="NfTableBody__cell NfTableBody__cell--right" >{nf.weight}</td>
              <td className="NfTableBody__cell NfTableBody__cell--right" >{nf.value}</td>
              <td className={`NfTableBody__cell NfTableBody__cell--right NfTableBody__cell--${nf.status}`} >{moment.isDate(nf.nfDate) ? moment(nf.nfDate).format('DD/MM/YYYY') : ''}</td>
            </tr>
          ))
        }
      </tbody>
    );
  }
}
